import { Text } from '@byecode/ui'
import type { OtherPlatformType } from '@lighthouse/shared'
import { useBreakpoint } from '@lighthouse/tools'
import React, { useEffect, useLayoutEffect, useMemo, useRef } from 'react'
import { useWindowSize } from 'react-use'
import styled from 'styled-components'

import { OtherPlatformsItem } from '../Item'
import type { IntegrationList, LookType } from '../types'

interface OtherPlatformsProps {
    list: IntegrationList
    activeType?: OtherPlatformType
    lookType: LookType
    onSelect?: (type?: OtherPlatformType) => void
    onInstall?: (type: OtherPlatformType) => void
}

const SCxTableContainer = styled.div`
    width: 100%;
    display: flex;
    padding: 0 22px;
    flex-direction: column;
    margin-top: 20px;
    gap: 32px;
`

const SCxKindContainer = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 16px;
`

const SCxKindContent = styled.div`
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
`

export const OtherPlatformsTable: React.FunctionComponent<OtherPlatformsProps> = ({ list, lookType, activeType, onInstall, onSelect }) => {
    // const { ref, width: breakPointWidth } = useBreakpoint()
    const { width: windowWidth } = useWindowSize()
    const ref = useRef<HTMLDivElement>(null)

    const [containerWidth, setContainerWidth] = React.useState(0)

    useLayoutEffect(() => {
        setContainerWidth(ref?.current?.getBoundingClientRect().width ?? 0)
    }, [windowWidth])

    const [itemWidth, itemNum] = useMemo(() => {
        const thresholds = [
            { min: 2701, num: 7 },
            { min: 2401, num: 7 },
            { min: 2001, num: 6 },
            { min: 1801, num: 5 },
            { min: 1501, num: 5 },
            { min: 1201, num: 4 },
            { min: 901, num: 3 },
            { min: 601, num: 2 },
            { min: 301, num: 1 }
        ]

        const found = thresholds.find(threshold => containerWidth > threshold.min)
        const num = found ? found.num : 1
        return [`${100 / num}%`, num]
    }, [containerWidth])

    const width = `calc(${itemWidth} - ${(20 * itemNum - 20) / itemNum}px )`

    return (
        <SCxTableContainer
            ref={ref}
            onClick={() => {
                onSelect?.(undefined)
            }}
        >
            {list.map(kind => {
                return (
                    <SCxKindContainer key={kind.categoryId}>
                        <Text weight={500} size={20} lineHeight="28px">
                            {kind.name}
                        </Text>
                        <SCxKindContent>
                            {kind.list.map(item => (
                                <OtherPlatformsItem
                                    key={item.id}
                                    lookType={lookType}
                                    width={width}
                                    activeType={activeType}
                                    data={item}
                                    onInstall={onInstall}
                                    onSelect={onSelect}
                                />
                            ))}
                        </SCxKindContent>
                    </SCxKindContainer>
                )
            })}
        </SCxTableContainer>
    )
}
